module.exports = __webpack_public_path__ + "img/img10.314baa85.svg";